export default {
    doctor: 'רופא',
    keywords: 'מילות מפתח',
    rank: 'דירוג',
    total: 'סה"כ',
    cover: 'כיסוי ביטוחי',
    speciality: 'התמחות'
}
